/* Register only the established generic booking frames; V5 and TV3 own theirs. */
(function () {
  "use strict";
  if (window.DRSKNN_BOOKING_ENTRY) return;
  if (["drsknn.com", "www.drsknn.com"].indexOf(window.location.hostname) === -1) return;
  var selector = "#pabauIframe, [data-drsknn-landing-modal-frame]";
  var registrations = [];
  var observer = null;

  function bookingUrl(raw) {
    if (typeof raw !== "string" || !raw.trim()) return null;
    try {
      var url = new URL(raw, window.location.href);
      if (url.protocol !== "https:" || ["drsknn.uk", "www.drsknn.uk"].indexOf(url.hostname) === -1
          || url.username || url.password || url.port) return null;
      if (!/^(?:\/$|\/clinic-kiosk\/?$|\/kiosk(?:\/|$)|\/book(?:\/|$))/.test(url.pathname)) return null;
      // Existing confirmation/recovery links are never rewritten into fresh checkout entries.
      if (["recovery", "cancelled", "paid"].some(function (key) { return url.searchParams.has(key); })
          || ["sid", "session_id"].some(function (key) { return /^cs_/.test(url.searchParams.get(key) || ""); })) return null;
      return url;
    } catch (_) { return null; }
  }

  function prepareUrl(raw) {
    var url = bookingUrl(raw);
    if (!url) return raw;
    url.hostname = "www.drsknn.uk";
    if (url.searchParams.get("booking_return") === "v5_completion_v2") return url.toString();
    var params = {
      booking_return: "website_completion_v3",
      booking_producer: "website_booking",
      booking_embed: "website_booking_modal",
      embed: "1", embedded: "1",
      parent_domain: window.location.hostname,
      return_url: window.location.origin + "/"
    };
    Object.keys(params).forEach(function (key) { url.searchParams.set(key, params[key]); });
    // Existing source, service, clinician, location, campaign and selection parameters remain intact.
    return url.toString();
  }

  function scan() {
    var api = window.DRSKNN_BOOKING_PARENT_BRIDGE;
    if (!api || typeof api.register !== "function") return;
    registrations = registrations.filter(function (item) {
      if (item.frame.isConnected && bookingUrl(item.frame.getAttribute("src"))) return true;
      item.handle.destroy();
      return false;
    });
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (frame) {
      var raw = frame.getAttribute("src") || "";
      if (!bookingUrl(raw)) return;
      var prepared = prepareUrl(raw);
      if (raw !== prepared) frame.setAttribute("src", prepared);
      if (registrations.some(function (item) { return item.frame === frame; })) return;
      var handle = api.register(frame, { completionOwner: false });
      if (handle) {
        registrations.push({ frame: frame, handle: handle });
        handle.sendPrivacy();
      }
    });
  }

  function install() {
    scan();
    if (!observer && typeof MutationObserver === "function" && document.documentElement) {
      observer = new MutationObserver(scan);
      observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["src"] });
    }
  }

  function openContained(raw) {
    var url = bookingUrl(raw);
    if (!url || typeof window.openPabauModal !== "function") return false;
    window.openPabauModal(prepareUrl(raw));
    scan();
    return true;
  }

  function openGeneric(raw) {
    var url = bookingUrl(raw);
    if (!url || url.pathname !== "/" || url.hash) return false;
    // Google's automatic linker may decorate a bare booking link before click.
    // The owned parent bridge supplies current consented identity to this frame.
    if (Array.from(url.searchParams.keys()).some(function (key) { return key !== "_gl"; })
        || url.searchParams.getAll("_gl").length > 1) return false;
    url.searchParams.delete("_gl");
    return openContained(url.toString());
  }

  window.DRSKNN_BOOKING_ENTRY = Object.freeze({
    version: "20260913-entry-v3", prepareUrl: prepareUrl, registerFrames: scan,
    openGeneric: openGeneric, openContained: openContained
  });
  // Legacy pricing uses this hook too; its newer page-specific adapter may replace it.
  if (typeof window.openDrSknnContainedBooking !== "function") {
    window.openDrSknnContainedBooking = function (raw) {
      if (openContained(raw)) return true;
      if (!bookingUrl(raw)) return false;
      // A missing popup must retain standalone consent/measurement ownership.
      window.location.assign(raw);
      return true;
    };
  }
  window.addEventListener("drsknn:booking-parent-bridge-ready", install);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", install, { once: true });
  else install();
})();
